module.exports = __webpack_public_path__ + "static/img/11.0cd12bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/11.png
// module id = /MuI
// module chunks = 0